import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import useAsync from "../hooks/useAsync";
import BookingServices from "../services/BookingServices";
import ViewBookingDetails from "./View Model/ViewBookingDetail";
import ViewInvoice from "./View Model/ViewInvoice";
import DeleteButton from "./Button/DeleteButton";
import BookingStatus from "./TogelButton/BookingStatus";
import Modal from "react-modal";
import ReactPaginate from "react-paginate";
import Pagetitle from "./PageTitle";
import * as XLSX from "xlsx";
import { Link } from "react-router-dom";

Modal.setAppElement("#root");

function Booking() {
  const { data, error, isLoading, run } = useAsync(BookingServices.getBooking);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isModalBookingOpen, setIsModalBookingOpen] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [dateFilter, setDateFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  const bookingsPerPage = 10;

  const handleViewDetails = (booking) => {
    setSelectedUser(booking);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
  };
  const handleViewBookingDetails = (booking) => {
    setSelectedBooking(booking);
    setIsModalBookingOpen(true);
  };

  const closeBookingModal = () => {
    setIsModalBookingOpen(false);
    setSelectedBooking(null);
  };

  const handlePageClick = (data) => {
    setCurrentPage(data.selected + 1);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return "N/A";
    }
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear().toString();
    return `${day}-${month}-${year}`;
  };

  const handleDateChange = (e) => {
    setDateFilter(e.target.value);
  };

  const handleStatusChange = (e) => {
    setStatusFilter(e.target.value);
  };

  const filteredBookings = data?.data?.filter((booking) => {
    const matchesSearch = booking?.cottage?.name
      ?.toLowerCase()
      .includes(searchQuery?.toLowerCase() || "") ||
      booking?.user?.name
      ?.toLowerCase()
      .includes(searchQuery?.toLowerCase() || "") ||
      booking?.bookingId
      ?.toLowerCase()
      .includes(searchQuery?.toLowerCase() || "");
    const matchesDate = dateFilter
      ? formatDate(booking?.createdAt) === formatDate(dateFilter)
      : true;
    const matchesStatus = statusFilter
      ? booking?.status?.toLowerCase() === statusFilter?.toLowerCase()
      : true;

    return matchesSearch && matchesDate && matchesStatus;
  });

  const indexOfLastUser = currentPage * bookingsPerPage;
  const indexOfFirstUser = indexOfLastUser - bookingsPerPage;
  const paginatedBookings = filteredBookings?.slice(
    indexOfFirstUser,
    indexOfLastUser
  );

  const generateExcel = () => {
    const filteredData = filteredBookings?.map((booking,index) => ({
      Sno: index+1,
      BookingId: booking?.bookingId,
      roomNumber: booking?.room?.roomNumber,
      UserName: booking?.user?.name || booking?.investor?.name,
      UserMobileno: booking?.user?.mobileNo || booking?.investor?.mobileNo,
      Cottage: booking?.cottage?.name,
      TotalAmount: booking?.totalAmount,
      Tax: booking?.tax,
      NoOfDays: booking?._id,
      CheckInDate : formatDate(booking?.checkInDate),
      CheckOutDate :formatDate(booking?.checkOutDate),
      UserType: booking?.user?.userType || booking?.investor?.userType,
      status: booking?.status,
    }));

    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Booking");
    XLSX.writeFile(wb, "booking_data.xlsx");
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  return (
    <div className="right_col" role="main">
      <Pagetitle />
      <div className="container-box px-0 user-manager" style={{ overflowX: "auto", whiteSpace: "nowrap", marginBottom: "20px" }}>
        <div className="container-box-top-header px-4">
          <div className="container-box-top-header-left-2">
            <input
              type="search"
              name="search"
              placeholder="Search by Booking Id, User Name & Cottage Name"
              value={searchQuery}
              onChange={(e)=>setSearchQuery(e.target.value)}
            />
            <button className="search-btn">
              <FontAwesomeIcon icon={faSearch} />
            </button>
          </div>

          <div className="sub-title-box-right d-flex">
            <div>
              <select
                value={statusFilter}
                onChange={handleStatusChange}
                style={{ backgroundColor: "#fff" }}
              >
                <option value="">Booking Status</option>
                <option value="Confirmed" style={{ color: "#699836" }}>
                  Confirm
                </option>
                <option value="Pending" style={{ color: "#F9B842" }}>
                  Pending
                </option>
                <option value="Cancelled" style={{ color: "#FF3333" }}>
                  Cancelled
                </option>
                <option value="Completed" style={{ color: "#699836" }}>
                  Completed
                </option>
              </select>
            </div>
            <div className="ms-3">
              <input type="date" id="dateInput" value={dateFilter} onChange={handleDateChange}/>
            </div>
            <button
              className="excel-btn site-btn-green ms-3"
              onClick={generateExcel}
            >
              <img src="img/excel-btn.svg" alt="" />
              <span className="ms-2">Download</span>
            </button>
          </div>
        </div>
        <div className="container-box-inner">
          <table
            id="example"
            className="table table-striped"
            style={{ width: "100%" }}
          >
            <thead>
            <tr>
                <th>S. No.</th>
                <th> BOOKING ID</th>
                <th>ROOM NO.</th>
                <th>USER TYPE</th>
                <th>USER NAME</th>
                <th> COTTAGE NAME</th>
                <th>Reg.date</th>
                <th>Check In date</th>
                <th>Check Out date</th>
                <th>Payment Status</th>
                <th>NO OF DAYS</th>
                <th>STATUS</th>
                <th>AMOUNT</th>
                <th>ACTION</th>
            </tr>
            </thead>
            <tbody>
              {paginatedBookings?.map((booking, index) => (
                <tr key={booking?._id}>
                  <td>{index + 1 + (currentPage - 1) * bookingsPerPage}</td>
                 
                  <td className="bookingId">{booking?.bookingId || 'N/A'}</td>
                  <td>{booking?.room?.roomNumber || 'N/A'}</td>
                  <td>{booking?.userType||booking?.user?.userType}</td>
                  <td>{booking?.user?.name ? booking?.user?.name : booking?.investor?.name}</td>
                  <td>{booking?.cottage?.name|| 'N/A'}</td>
                  <td>{formatDate(booking?.createdAt|| 'N/A')}</td>
                  <td>{formatDate(booking?.checkInDate|| 'N/A')}</td>
                  <td>{formatDate(booking?.checkOutDate|| 'N/A')}</td>
                  <td>{booking?.paymentStatus|| 'N/A'}</td>
                  <td>{booking?.noOfDays|| 'N/A'}</td>
                  <td className="status-toggle">
                    <BookingStatus data={booking} page="Booking" onSuccess={run} />
                  </td>
                  <td>{booking?.totalAmount|| 'N/A'}</td>
                  <td> 
                      <button className="edit trans-btn"  onClick={() => handleViewBookingDetails(booking)}><img src="img/view-btn.svg" alt=""/></button>
                      <button className="edit trans-btn"  onClick={() => handleViewDetails(booking)}><img src="img/invoice-format.svg" alt=""/></button>
                  </td>
                </tr>
              ))}

            
            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="pagination">
          <ReactPaginate
            pageCount={Math.ceil((filteredBookings?.length || 0) / bookingsPerPage)}
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            activeClassName={"active"}
            previousLabel={"Previous"}
            nextLabel={"Next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            initialPage={currentPage - 1}
            disableInitialCallback={true}
            pageLinkClassName={"page-link"}
            previousLinkClassName={"page-link"}
            nextLinkClassName={"page-link"}
            pageClassName={"page-item"}
            previousClassName={"page-item"}
            nextClassName={"page-item"}
            disabledClassName={"disabled"}
          />
        </div>
      </div>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="User Details"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <ViewInvoice booking={selectedUser} closeModal={closeModal} />
      </Modal>
      <Modal
         isOpen={isModalBookingOpen}
         onRequestClose={closeBookingModal}
         contentLabel="User Details"
         className="modal-content"
         overlayClassName="modal-overlay"
       >
         <ViewBookingDetails booking={selectedBooking} closeModal={closeBookingModal} />
      </Modal>
    </div>
  );
}

export default Booking;
